var common = require('./common');

jQuery(function($) {
  $('body').on('change', 'input[type=radio][name="price-donation"]', function() {
    var value  = $(this).val()
    var amount = $(this).data('amount')
    var dtax   = $(this).data('dtax')

    if ( value == 'free' )
    {
      $('.price-donation-free').removeClass('hide')
      $('.price-donation-free').val(amount)
    }
    else
    {
      $('.price-donation-free').addClass('hide')
    }

    $('#price-donation-text .n1').html(amount.toString().replace('.', ','))
    var t = amount * dtax / 100
    $('#price-donation-text .n2').html(t.toString().replace('.', ','))

    sentenceSummaryUpdate()
  })

  $('body').on('change paste keyup', '.price-donation-free', function() {
    var amount = $(this).val()
    var dtax = $(this).data('dtax')

    $('#price-donation-text .n1').html(amount.toString().replace('.', ','))
    var t = amount * dtax / 100
    $('#price-donation-text .n2').html(t.toString().replace('.', ','))

    sentenceSummaryUpdate()
  })

  $('body').on('change', 'input[type=radio][name="receiver-donation"]', function() {
    sentenceSummaryUpdate()
  })

  $('body').on('change', 'input[type=radio][name="radio-payment"]', function() {
    sentenceSummaryUpdate()
    updateBtnControl()
  })

  var action_done = false
  $('body').on('click', '.btn-checkout-payment-donation', function(e) {

    var $el = $(this)
    if ( $el.data('action') == 'next' )
    {
      e.preventDefault()
      action_done = false
    }
    else if ( $el.data('action') == 'finish' )
    {
      e.preventDefault()
      action_done = false
      common.globalLoader(true)
    }

    if ( action_done == false )
    {
      var data = {
        action: $el.data('action'),
        amount: getAmountDonation(),
        receiver: $('input[type=radio][name="receiver-donation"]:checked').data('title'),
        pm: $('input[type=radio][name="radio-payment"]:checked').val(),
        product: $('input[type=radio][name="price-donation"]:checked').val()
      }
      var request = $.ajax({
        url: '/donation/save/data',
        data: data,
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( $el.data('action') == 'finish' )
          {
            common.requestPaymentCheckout($('input[name=radio-payment]:checked').val(), 'donation')
          }
          else if ( $el.data('action') == 'next' )
          {
            window.location.href = $el.attr('href')
          }
          else
          {
            action_done = true
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          common.globalLoader(false)
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
  })

  var btn_blocked = false
  $('body').on('click', '.btn-finish-payment-donation', function(e) {
    e.preventDefault()

    if ( !btn_blocked )
    {
      var error = false
      if ( $('input[name=radio-facturation]:checked').val() == undefined )
      {
        error = true
      }

      if ( error )
      {
        $.notify({
          message: Drupal.t('Vous devez sélectionner une adresse de facturation.')
        },{
          z_index: 2000,
          allow_dismiss: false,
          type: 'danger'
        })
      }
      else
      {
        btn_blocked = true
        common.globalLoader(true)
        var request = $.ajax({
          url: '/donation/save/address',
          data: {
            address: $('input[name=radio-facturation]:checked').val()
          },
          method: 'post',
          cache: false,
          dataType: 'json',
          success: function (data)
          {
            common.requestPaymentCheckout(data.pm, 'donation')
          },
          error: function (XMLHttpRequest, textStatus, errorThrown)
          {
            common.globalLoader(false)
            if ( errorThrown != 'abort' )
            {
              console.log(XMLHttpRequest);
              console.log(textStatus);
              console.log(errorThrown);
            }
          }
        })
      }
    }
  })

  var updateBtnControl = function()
  {
    var request = $.ajax({
      url: '/donation/checkdata',
      data: {
        pm: $('input[name=radio-payment]:checked').val()
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        $('#donation-control-step2').html(data.html)
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        common.globalLoader(false)
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  }

  var getAmountDonation = function()
  {
    var recap_txt1 = ''
    if ( $('input[type=radio][name="price-donation"]:checked').val() != undefined )
    {
      if ( $('input[type=radio][name="price-donation"]:checked').val() == 'free' )
      {
        recap_txt1 = $('input[name="price-donation-free"]').val()
      }
      else
      {
        recap_txt1 = $('input[type=radio][name="price-donation"]:checked').data('amount')
      }
    }

    return recap_txt1
  }

  var sentenceSummaryUpdate = function()
  {
    var show = false
    var recap_txt1 = getAmountDonation()
    var recap_txt2 = ''
    var recap_txt3 = ''

    if ( $('input[type=radio][name="receiver-donation"]:checked').val() != undefined )
    {
      recap_txt2 = $('input[type=radio][name="receiver-donation"]:checked').data('title')
    }

    if ( $('input[type=radio][name="radio-payment"]:checked').val() != undefined )
    {
      recap_txt3 = $('input[type=radio][name="radio-payment"]:checked').data('title')
    }

    $('#text-block-content-section .recap_txt1').html(recap_txt1);
    $('#text-block-content-section .recap_txt2').html(recap_txt2);
    $('#text-block-content-section .recap_txt3').html(recap_txt3);

    if ( recap_txt1 != '' && recap_txt2 != '' && recap_txt3 != '' )
    {
      $('#text-block-content-section').removeClass('hide')
    }
    else
    {
      $('#text-block-content-section').addClass('hide')
    }
  }
})



// WEBPACK FOOTER //
// ./js/donation.js